import budgetSourceLogo from '../assets/logos/Budget-Source.svg';
import essentialsForHomeLogo from '../assets/logos/efh-logo.svg';
import homePlayLogo from '../assets/logos/Homeplay_Logo.png';
import savingsCentralLogo from '../assets/logos/savingscentral.png';
import tasteForSavingsLogo from '../assets/logos/tasteForSavings.png';

export const membershipInfoList = {
	32: {
		name: 'HomePlay',
		logo: homePlayLogo,
		blurb:
			'With HomePlay, fun is always in the budget-score sweet deals and rebates on everything from bowling nights out to board game battles at home!'
	},
	42: {
		name: 'Essentials for Home',
		logo: essentialsForHomeLogo,
		blurb:
			'Your inside pass to discounted gift cards, cash back rebates, and exclusive home improvement deals to turn your DIY, fixer-upper dreams into reality.'
	},
	57: {
		name: 'Budget Source',
		logo: budgetSourceLogo,
		blurb:
			'Access a wide variety of coupons, local discounts, and cashback offers with Budget Source.'
	},
	65: {
		name: 'Taste for Savings',
		logo: tasteForSavingsLogo,
		blurb:
			'Enjoy discounts at your favorite restaurants and save on dining with Taste for Savings.'
	},
	74: {
		name: 'Savings Central',
		logo: savingsCentralLogo,
		blurb:
			'Your one-stop-shop for every-day savings: get access to discounted gift cards, cash-back rebates, and everyday deals on household essentials with Savings Central.'
	}
};
